//Styles
import './App.css';

//React Router
import { Route, Routes } from 'react-router-dom';
//React imports
import { useEffect, useState } from 'react';

import Footer from './components/Footer';
//Pages
import Home from './pages/Home';
//Components
import Navbar1 from './components/Navbar1';
import News from './pages/News';
import Products from './pages/Products';
import RoadMap from './pages/RoadMap';
import Software from './pages/Software';
import Technology from './pages/Technology';

//Import Counter

function App() {
  return (
    <div className="app">
      <Navbar1 />
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/news" element={<News />} />
        <Route
          path="/roadmap"
          element={
            <div>
              <RoadMap />
            </div>
          }
        />
        <Route path="/software" element={<Software />} />
        <Route path="/products" element={<Products />} />
        <Route path="/technology" element={<Technology />} />
      </Routes>
      <div style={{ height: '150px' }}></div>
      <Footer />
    </div>
  );
}

export default App;
